import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { Referral } from '../components/Settings/Referral/Referral'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PKEY!)

export const ReferralPage = () => {
    return (
        <Elements stripe={stripePromise}>
            <Referral />
        </Elements>
    )
}
